export enum SortMethod {
  Unsorted,
  PopularityDescending,
}
